import { render, staticRenderFns } from "./evaluationBid.vue?vue&type=template&id=a8013da2"
import script from "./evaluationBid.vue?vue&type=script&lang=js"
export * from "./evaluationBid.vue?vue&type=script&lang=js"
import style0 from "./evaluationBid.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports